<template>
    <div>
        <v-btn
            color="accent"
            :disabled="loading || !inputsFilled"
            @click="clicked"
            :loading="loading"
            rounded
            style="height: 40px"
        >
            Calculate
        </v-btn>
        <div style="min-height: 20px">
            <v-expand-transition>
                <div
                    class="red--text pb-0 mb-0"
                    style="font-size: 12px"
                    v-show="!inputsFilled"
                >
                    Required inputs missing
                </div>
            </v-expand-transition>
        </div>
    </div>
</template>
<script setup>
import { computed } from 'vue'

const props = defineProps(['calc', 'loading'])
const emit = defineEmits(['click'])

const inputsFilled = computed(() => {
    if (props.calc.inputs) {
        let emptyRequiredInput = false
        props.calc.inputs.forEach((i) => {
            if (!(i.value || i.value === 0) && !i.isOptional)
                emptyRequiredInput = true
        })
        return !emptyRequiredInput
    }
    return true
})

function clicked() {
    emit('click')
}
</script>
